import React from 'react'
import styled, { keyframes } from 'styled-components'
// @ts-ignore
import { QLogo } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { setAutoId } from 'utils/automationUtil'

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const StyledLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > svg {
    animation: ${rotateAnimation} 1s linear infinite;
  }
`

interface SpinningQProps {
  className?: string
  size?: number
  testId?: string
  color?: string
}

const SpinningQ = ({ className, size = 16, testId, color }: SpinningQProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledLogo {...(testId && setAutoId(testId))} className={className}>
      <QLogo fontSize={size} mode={theme} color={color} />
    </StyledLogo>
  )
}

export default SpinningQ
